import 'reflect-metadata';
import { Service } from 'typedi';
import type { CardTypeStrategyData } from '../../types/card-strategy-data.type';
import type { SearchApiDocument } from '../../../../api/model/response/documents/SearchResult';
import { StrategyBuilder } from '../../StrategyBuilder';
import { CardStrategyService } from '../../CardStrategyService';

@Service({ id: 'b2cPublicCardStrategyService' })
export class B2cPublicCardStrategyBuilder extends StrategyBuilder<CardStrategyService> {
  build(details: CardTypeStrategyData): CardStrategyService {
      return new B2cPublicCardStrategyService(details);
  }
}

export class B2cPublicCardStrategyService extends CardStrategyService {
  details;
  constructor(details: CardTypeStrategyData) {
      super();
      this.details = details;
  }

  makeCard(doc: SearchApiDocument): string {
      if (this.details.params.tabType === 'b2c/products') {
        return 'uiaas-search-result-product-b2c';
      } else if (this.details.params.tabType === 'b2c/resources') {
        return 'uiaas-search-result-resource-b2c';
      } else if (this.details.params.tabType === 'b2c/video') {
        return 'uiaas-search-result-video-v2';
      } else{
        return 'uiaas-search-result-basic-prsm';
      }
  }

  getCardProps(
    doc: SearchApiDocument,
    params: Record<string, string>
  ): Record<string, string> {
      if (this.details?.params) {
        return this.details.params;
      }
      return {};
  }
}
